import ArrayUtils from '@/utils/arrayUtils'

export default
{
    namespaced: true,
    
    state:
    {
        infoList: []
    },

    getters:
    {
        getInfoById: state => id =>
        {
            return state.infoList.find(i => i.id == id)
        }
    },

    mutations:
    {
        setInfoList (state, infos)
        {
            state.infoList = infos
        },

        updateInfoList (state, infos) 
        {
            var merged = ArrayUtils.mergeArrays(state.infoList, infos, (a, b) => a.id == b.id)

            merged = merged.sort((a, b) =>
            {
                if (a.isUncreated) return -Infinity

                return a.orderId - b.orderId
            })

            state.infoList = merged
        }
    },

    actions:
    {
        removeInfoById ({ getters, state }, id)
        {
            let info = getters.getInfoById(id)
            
            if (!info) return
            
            const infos = state.infoList
            infos.splice(infos.indexOf(info), 1)

            state.infoList = infos
        }
    }
}


// WEBPACK FOOTER //
// ./src/stores/usefulInfos.js